import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4479 3.698H2.55208C1.91926 3.698 1.40625 4.21101 1.40625 4.84383V17.448C1.40625 18.0808 1.91926 18.5938 2.55208 18.5938H17.4479C18.0807 18.5938 18.5938 18.0808 18.5938 17.448V4.84383C18.5938 4.21101 18.0807 3.698 17.4479 3.698Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.40625 8.28125H18.5938",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.9895 5.41667V1.40625",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0103 5.41667V1.40625",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
